(function ($) {
    $.fn.equalHeight = function () {
        var heights = [];
        var maxHeight = 0;

        $(this).css('height', 'auto');
        $(this).each(function () {
            heights.push($(this).innerHeight());
        });

        maxHeight = heights.sort(function (a, b) {
            return b - a;
        })[0];

        $(this).css('height', maxHeight);
    };
})(jQuery);